import { lazy } from 'react';

export const ChallengeRemoveForm = lazy(() => import('./ChallengeRemoveForm'));
